export const CSS_CLASSES = {
  SEPARATOR_ROOT: "separator",

  SEPARATOR_VERTICAL: "separator-vertical",
  SEPARATOR_HORIZONTAL: "separator-horizontal",

  SEPARATOR_VERTICAL_GAP_XS: "separator-vertical-gap-xs",
  SEPARATOR_VERTICAL_GAP_SM: "separator-vertical-gap-sm",
  SEPARATOR_VERTICAL_GAP_MD: "separator-vertical-gap-md",
  SEPARATOR_VERTICAL_GAP_LG: "separator-vertical-gap-lg",
  SEPARATOR_VERTICAL_GAP_XL: "separator-vertical-gap-xl",

  SEPARATOR_HORIZONTAL_GAP_XS: "separator-horizontal-gap-xs",
  SEPARATOR_HORIZONTAL_GAP_SM: "separator-horizontal-gap-sm",
  SEPARATOR_HORIZONTAL_GAP_MD: "separator-horizontal-gap-md",
  SEPARATOR_HORIZONTAL_GAP_LG: "separator-horizontal-gap-lg",
  SEPARATOR_HORIZONTAL_GAP_XL: "separator-horizontal-gap-xl",
};
